import baseClient from './baseClient';

const changeCaptain = async (teamId, newCaptainId) => {
    return baseClient.patch(
        `team/${teamId}/change-captain`,
        { captain: newCaptainId }
    );
}

const getTransferStatus = async (teamId) => {
    return baseClient.get(`team/${teamId}/transfer-status`);
}

const setWildcardGameweek = async (teamId, wildcardGameweek) => {
    return baseClient.post(
        `team/${teamId}/activate-wildcard`,
        { gameweek: wildcardGameweek }
    );
}

const getTransferRecommendations = async (teamId) => {
    return baseClient.get(`team/${teamId}/transfer-recommendations`);
}

const getTeamData = async (teamId, gameweek) => {
    return baseClient.get(
        `team/${teamId}`,
        { params: { gameweek: gameweek } }
    );
}

const activateTripleCaptain = async (teamId, gameweek) => {
    return baseClient.post(
        `team/${teamId}/activate-triple-captain`,
        { gameweek: gameweek }
    );
}

const makeTransfers = async (teamId, nextPlayerIds) => {
    return baseClient.post(
        `team/${teamId}/transfers`,
        {
            nextPlayers: nextPlayerIds
        }
    );
}

const getTeamList = async (year) => {
    return baseClient.get(`team/all/${year}`);
}

const getMiniLeagueTeamList = async (leagueCode) => {
    return baseClient.get(`mini-leagues/${leagueCode}`);
}

const deleteTeam = async (userId) => {
    return baseClient.delete(`team/delete-by-user-id/${userId}`);
}

const createTeam = async (teamPlayers, teamCaptain, teamName) => {
    return baseClient.post(
        'team/create',
        {
            selectedPlayers: teamPlayers,
            captain: teamCaptain,
            teamName: teamName
        }
    );
}

const changeTeamName = async (teamId, teamName) => {
    return baseClient.post(
        `team/${teamId}/change-team-name`,
        {
            teamName: teamName
        }
    );
}

const getArchiveTeamStandingYears = async () => {
    return baseClient.get('team/archive-tables');
}

const getNetTransfers = async (teamId) => {
    return baseClient.get(`team/${teamId}/net-transfers`);
}

const getTeamOfTheWeekData = async () => {
    return baseClient.get('team/team-of-the-week');
}

export {
    changeCaptain,
    getTransferStatus,
    setWildcardGameweek,
    getTransferRecommendations,
    getTeamData,
    activateTripleCaptain,
    makeTransfers,
    getTeamList,
    deleteTeam,
    createTeam,
    getArchiveTeamStandingYears,
    changeTeamName,
    getNetTransfers,
    getTeamOfTheWeekData,
    getMiniLeagueTeamList
};
